import { useAppSelector } from '../../redux/hooks'
import { useEffect } from 'react'
import { getIsServicePickerOpen } from '../../redux/reducers/calendarSettings'
import { useBFSM, useBFSMState } from '../../contexts/bfsmContext'
import { StateComponentSwitcher } from './statecomponentswitcher'
import { setBookingId, setFlow } from '../../redux/reducers/appSettings'
import {
    initiateBookingWithKlippeKort,
    initiateRebooking,
} from '../../contexts/bfsmContext'
import { setIsMobile } from '../../redux/reducers/appSettings'
import { useMediaQuery } from 'react-responsive'
import {
    AddressActions,
    AddressState,
    BookingflowStateMachine,
    SuggestionMapper,
} from '@raskrask-dk/bookingflow-state-machine'
import { useQuery } from '../../services/hooks/useQuery'
import { useAppDispatch } from '../../redux/hooks'
import { useParams } from 'react-router-dom'

// Async function for better error handling and readability
const processSuggestions = async (
    queries: URLSearchParams,
    BFSM: BookingflowStateMachine
): Promise<void> => {
    const values = Object.fromEntries(queries.entries())
    const mapper = new SuggestionMapper()

    try {
        const suggestions = await mapper.fromAny(values)

        BFSM.addSuggestions = suggestions // address + customer details

        const currentAddressState = BFSM.currentState()
        if (currentAddressState.type === 'ADDRESS') {
            // This is very important. If we do not check for this, then this function might run in a loop
            const addrNext = new AddressActions.Next(
                currentAddressState as AddressState,
                suggestions.address
            )

            if (addrNext.isValid()) {
                BFSM.doAction(AddressActions.Next, suggestions.address)
            }
        }
    } catch (err) {
        console.error('Error while processing suggestions:', err)
    }
}

const Base = (): JSX.Element => {
    const currentState = useBFSMState()

    const isServicePickerOpen = useAppSelector((state) =>
        getIsServicePickerOpen(state)
    )

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [currentState, isServicePickerOpen])

    const dispatch = useAppDispatch()
    const [BFSM, setBFSM] = useBFSM()

    const { bookingId, flow } = useParams() as {
        bookingId?: string
        flow: FlowTypeReact
    }
    const queries = useQuery()

    const isMobileView = useMediaQuery({ maxWidth: 640 })
    useEffect(() => {
        dispatch(setIsMobile(isMobileView))
    }, [isMobileView])

    useEffect(() => {
        if (flow) {
            if (flow === 'bookwithklippe') {
                const values = Object.fromEntries(queries.entries())
                new SuggestionMapper().fromAny(values).then((suggestions) => {
                    BFSM.addSuggestions = suggestions // address, basisTypeId, customerType, goalId, serviceTypeId, partnerId, customerName, customerEmail, customerPhone
                    initiateBookingWithKlippeKort(BFSM, suggestions, dispatch)
                })
                dispatch(setFlow(flow))
            } else {
                if (bookingId && flow === 'rebook') {
                    console.log('rebooking')
                    initiateRebooking(BFSM, bookingId, dispatch)
                } else if (bookingId && flow === 'movebook') {
                    setBFSM('MoveBooking')
                } else if (bookingId && flow === 'cancelbook') {
                    setBFSM('CancelBooking')
                } else if (bookingId && flow === 'admincancelbook') {
                    setBFSM('AdminCancelBooking')
                }

                dispatch(setFlow(flow))
                dispatch(setBookingId(bookingId))
            }
            history.pushState({}, document.title, '/')
        } else {
            processSuggestions(queries, BFSM)
        }
    }, [])

    return <StateComponentSwitcher state={currentState.type} />
}

export { Base }
